import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const PromptsPage = lazy(() =>
    import(/* webpackChunkName: "prompts" */ '../ui/PromptsPage').then(m => ({
        default: m.PromptsPage,
    })),
);

const promptsPath = '/prompts';

export const promptsLocations: Location[] = [
    {
        url: promptsPath,
        Component: PromptsPage,
    },
];
